import colors from "../../base/colors";
import typography from "../../base/typography";

import pxToRem from "../../functions/pxToRem";

const { text, info, secondary, transparent } = colors;
const { size } = typography;

const buttonText = {
  base: {
    backgroundColor: transparent.main,
    minHeight: pxToRem(37),
    color: text.main,
    boxShadow: "none",
    padding: `${pxToRem(9)} ${pxToRem(24)}`,

    "&:hover": {
      backgroundColor: transparent.main,
      boxShadow: "none",
    },

    "&:focus": {
      boxShadow: "none",
    },

    "&:active, &:active:focus, &:active:hover": {
      opacity: 0.85,
      boxShadow: "none",
    },

    "&:disabled": {
      boxShadow: "none",
    },

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(16)} !important`,
    },
  },

  small: {
    minHeight: pxToRem(29),
    padding: `${pxToRem(6)} ${pxToRem(18)}`,
    fontSize: size.xs,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },

  large: {
    minHeight: pxToRem(44),
    padding: `${pxToRem(12)} ${pxToRem(64)}`,
    fontSize: size.sm,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(22)} !important`,
    },
  },

  primary: {
    color: colors.primary.main,

    "&:hover": {
      color: colors.primary.focus,
    },

    "&:focus:not(:hover)": {
      color: colors.primary.focus,
      boxShadow: "none",
    },
  },

  secondary: {
    color: secondary.main,

    "&:hover": {
      color: secondary.main,
    },

    "&:focus:not(:hover)": {
      color: secondary.focus,
      boxShadow: "none",
    },
  },

  success: {
    color: colors.success.main,

    "&:hover": {
      color: colors.success.main,
    },

    "&:focus:not(:hover)": {
      color: colors.success.focus,
      boxShadow: "none",
    },
  },

  warning: {
    color: colors.warning.main,

    "&:hover": {
      color: colors.warning.main,
    },

    "&:focus:not(:hover)": {
      color: colors.warning.focus,
      boxShadow: "none",
    },
  },

  error: {
    color: colors.error.main,

    "&:hover": {
      color: colors.error.main,
    },

    "&:focus:not(:hover)": {
      color: colors.error.focus,
      boxShadow: "none",
    },
  },

  dark: {
    color: colors.text.main,

    "&:hover": {
      color: colors.text.focus,
    },

    "&:focus:not(:hover)": {
      color: colors.text.focus,
      boxShadow: "none",
    },
  },
};

export default buttonText;
